import { Container, Row, Image } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import css from "./Home.module.css";
import { HomeImage } from "../../assets/Images";
import Button from "../../common/Button";

function Home() {
  return (
    <Container fluid className={css.home} id="home">
      <Row className={css.row}>
        <Col md={6} className={css.heroContent}>
          <p className={css.kicker}>WEBZOVA STUDIO</p>
          <h1>We build fast, modern digital experiences.</h1>
          <p className={css.subtitle}>
            Specializing in{" "}
            <span className="text-highlight">Web Development</span>,{" "}
            <span className="text-highlight">Custom Software</span>, and{" "}
            <span className="text-highlight">UI/UX Design</span> for growing
            businesses.
          </p>
          <div className={css.heroActions}>
            <button className={css.ghostBtn}>
              <a href="/#Services">View our work</a>
            </button>
          </div>
        </Col>

        <Col md={6} className={css.heroImageCol}>
          <div className={css.heroImageWrap}>
            <Image src={HomeImage} alt="WebZova hero visual" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
